"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSongwriter = exports.searchSongwriterCatalogSuggestions = exports.searchSongwriterCatalog = exports.writerUpdateRequest = exports.unlinkSongwriterWriter = exports.linkSongwriterWriter = exports.searchSongwriterWriterLinks = exports.searchSongwriterWriters = exports.getSongwriterSummary = exports.getSongwriters = void 0;
const api_client_1 = require("@App/api/api-client");
const pathes_1 = __importDefault(require("@App/dicts/pathes"));
const getSongwriters = (params, nameFilter) => api_client_1.axiosClient.get(pathes_1.default.Songwriter.list, {
    params: { page: params.page ? params.page - 1 : undefined, size: params.limit, name: nameFilter },
});
exports.getSongwriters = getSongwriters;
const getSongwriterSummary = (id) => api_client_1.axiosClient.get(pathes_1.default.Songwriter.summary(id));
exports.getSongwriterSummary = getSongwriterSummary;
const searchSongwriterWriters = (pagination, id, search) => api_client_1.axiosClient.post(pathes_1.default.Songwriter.writerSearch(pagination, id), search);
exports.searchSongwriterWriters = searchSongwriterWriters;
const searchSongwriterWriterLinks = (id, writerIpIds) => api_client_1.axiosClient.post(pathes_1.default.Songwriter.writerLinkSearch(id), { affWriterIpIds: writerIpIds });
exports.searchSongwriterWriterLinks = searchSongwriterWriterLinks;
const linkSongwriterWriter = (id, writerIpId) => api_client_1.axiosClient.post(pathes_1.default.Songwriter.linkWriter(id, writerIpId));
exports.linkSongwriterWriter = linkSongwriterWriter;
const unlinkSongwriterWriter = (id, writerIpId) => api_client_1.axiosClient.delete(pathes_1.default.Songwriter.linkWriter(id, writerIpId));
exports.unlinkSongwriterWriter = unlinkSongwriterWriter;
const writerUpdateRequest = (id, writerIpId, writerName, reason, formData) => {
    const { correctSpelling, reasonForCorrection } = formData;
    return api_client_1.axiosClient.post(pathes_1.default.Songwriter.writerUpdateRequest(id, writerIpId), {
        reason,
        writerName,
        reasonForCorrection,
        correctSpelling,
    });
};
exports.writerUpdateRequest = writerUpdateRequest;
const searchSongwriterCatalog = (id, pagination, search) => api_client_1.axiosClient.post(pathes_1.default.Songwriter.searchSongwriterCatalog(id, pagination), search);
exports.searchSongwriterCatalog = searchSongwriterCatalog;
const searchSongwriterCatalogSuggestions = (id, property, searchTerm) => api_client_1.axiosClient.get(pathes_1.default.Songwriter.searchSongwriterCatalogSuggestions(id, property, searchTerm));
exports.searchSongwriterCatalogSuggestions = searchSongwriterCatalogSuggestions;
const createSongwriter = (data) => api_client_1.axiosClient.post(pathes_1.default.Songwriter.list, data);
exports.createSongwriter = createSongwriter;
